export function form ($parent = document) {
  let $inputs = $parent.querySelectorAll('.form-field input, .form-field textarea')

  $inputs.forEach(($input) => {
    $input.addEventListener('focus', () => {
      $input.parentElement.classList.add('has-focus', 'has-input')
    })
    $input.addEventListener('blur', () => {
      if ($input.value === '') {
        $input.parentElement.classList.remove('has-input')
      }
      $input.parentElement.classList.remove('has-focus')
    })
    $input.addEventListener('focus', () => {
      $input.parentElement.classList.remove('with-error', 'with-warning', 'with-info', 'with-success')
    })

    // init
    // make field with value remain
    if ($input.value !== '') {
      // should be form-field
      $input.parentElement.classList.add('has-input')
    }
  })
}

export function handleErrors (errors, fields, options = {}) {
  let defaultOptions = {
    errorClass: 'with-error',
    feedbackClass: 'feedback'
  }
  options = Object.assign({}, defaultOptions, options)
  if (!errors || Object.keys(errors).length <= 0) return
  fields.forEach((field) => {
    if (errors[field]) {
      let $field = document.querySelector('#' + field)
      if (!$field) {
        console.error(`[form.js::handleErrors] ${field} element is not present`)
        return
      }
      $field.parentElement.classList.add('has-input', options.errorClass)
      let helpBlock = $field.parentElement.querySelector('p')
      if (!helpBlock) {
        helpBlock = document.createElement('p')
        helpBlock.classList.add(options.feedbackClass)
        $field.parentElement.appendChild(helpBlock)
      }
      helpBlock.innerText = errors[field]
    }
  })
}

export function resetErrors (fields, options) {
  let defaultOptions = {
    classList: ['with-error', 'with-warning', 'with-info', 'with-success']
  }
  options = Object.assign({}, defaultOptions, options)
  fields.forEach((field) => {
    let $field = document.querySelector('#' + field)
    if (!$field) {
      console.error(`[form.js::resetErrors] ${field} element is not present`)
    } else {
      options.classList.forEach(className => $field.parentElement.classList.remove(className))
      let helpBlock = $field.parentElement.querySelector('p')
      if (helpBlock) {
        helpBlock.innerText = ''
      }
    }
  })
}

export default form



// WEBPACK FOOTER //
// ./resources/assets/js/form.js